import posthog from "posthog-js";
if (
  !window.location.host.includes("127.0.0.1") &&
  !window.location.host.includes("localhost") &&
  !window.location.host.includes("staging")
) {
  posthog.init("phc_iTfAKrbSTB4UFjJ4zmpCZYUcf2N8pfmFPCMznRIHZcy", {
    api_host: "https://eu.posthog.com",
    persistence: "memory",
    autocapture: false,
  });
}
